const DEF_PRIMARY_COLOR = "#163C68";
const DEF_SECONDARY_COLOR = "#2BB474";
const format = {
  date: {
    long: "D MMMM YYYY",
    short: "D MMM YY",
  },
  datetime: {
    long: "DD MMMM HH:mm:ss",
    middle: "DD MMMM YY HH:mm",
    short: "D MMM HH:mm",
  },
  time: {long: "HH:mm:ss", short: "HH:mm"},
};

export {DEF_PRIMARY_COLOR, DEF_SECONDARY_COLOR, format};
